import TestimonialsContainer from './testimonials_container';

const Testimonials = TestimonialsContainer;
export default Testimonials;
